import React, { useEffect, useState } from "react";
import "./duplex.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import Navbarmint from "../landing/headermint/Navbarmint";
import { Link, useNavigate, useParams } from "react-router-dom";
import ReactImageGallery from "react-image-gallery";
import axios from "axios";
import BuyNFT from "../../hooks/dataSenders/BuyNFT";
import Loader from "../../hooks/loader";
import { toast } from "react-toastify";
import FetchHash from "../../hooks/dataFetchers/fetchHash";
import { useWeb3React } from "@web3-react/core";
import useWeb3 from "../../hooks/useWeb3";
import FetchMintedNFT from "../../hooks/dataFetchers/fetchMintedNFT";
import Sucessmodal from "../../utils/Sucessmodal";
import { MerkleTree } from "merkletreejs";
import keccak256 from "keccak256";
import { ethers } from "ethers";
import { Buffer } from "buffer";
import PublicBuyNft from "../../hooks/dataSenders/PublicBuyNft";

// Polyfill for Buffer
window.Buffer = Buffer;

const Duplex = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate();
  const { account } = useWeb3React();
  const web3 = useWeb3();

  const { id } = useParams();

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [loader, setLoader] = useState(false);
  const [baseUri, setBaseURi] = useState(null);
  const [metadataArray, setMetadataArray] = useState(null);
  const [nftCount, setNftCount] = useState(0);

  const [totalCount, setTotalCount] = useState(0); // Total count of minted NFTs

  const increseCount = () => {
    console.log(nftCount, "increseCount");

    // Check if we can increase the count without exceeding total supply
    if (totalCount + nftCount < 100 && nftCount < 10) {
      setNftCount((prevCount) => prevCount + 1);
      setTotalCount((prevTotal) => prevTotal + 1); // Increment total count
    }
  };

  const decreseCount = () => {
    console.log(nftCount, "decreseCount");

    if (nftCount > 0) {
      setNftCount((prevCount) => prevCount - 1);
      setTotalCount((prevTotal) => prevTotal - 1); // Decrement total count
    }
  };

  const [error, setError] = useState(""); // State for error message
  console.log(error, "errrorr");

  const handleInputChange = (e) => {
    const value = e.target.value;

    // Parse the value to an integer
    const parsedValue = parseInt(value, 10);

    if (!isNaN(parsedValue)) {
      // Set the nftCount based on the user input
      setNftCount(parsedValue);

      // Check if the input exceeds 10
      if (parsedValue > 10) {
        setError("You can only enter a maximum of 10 NFTs at a time.");
      } else {
        setError(""); // Clear error if input is valid
      }

      // Check if totalCount with newValue exceeds 100
      if (totalCount + parsedValue <= 100) {
        // You can also set totalCount based on valid inputs if needed
      } else {
        // Adjust logic based on totalCount
        setNftCount(10 - (totalCount - 100)); // Adjust based on totalCount
      }
    } else {
      setNftCount(0); // Reset to 0 if the input is not a number
      setError(""); // Clear error if input is invalid
    }
  };

  const { FetchHashHook } = FetchHash();
  const { fetchMintedNFThHook } = FetchMintedNFT();
  const { BuyNFTHook } = BuyNFT();
  const { publicBuyNftHook } = PublicBuyNft();

  // ======================================== Verify wallet address ====================================

  // const [isValid, setIsValid] = useState(false);
  const [myData, setMyData] = useState([]);
  const [tree, setTree] = useState(null);

  // console.log(isValid, "isValid okokok");

  // Your wallet addresses
  // const [root, setRoot] = useState("");

  const walletAddresses = [
    "0x6F3fDdF3B497caB73C10A314f63a72d8D9F89C1a",
    "0xa350bd49EbD8063c4b7fd047b9733Dfa007A6Ea9",
    "0x325B0d9E954740E3Ac68AC3eb4034028A814Fc46",
    "0x4F2E9A44101b91e43dB872D957Bb7A2155ff17af",
  ];

  useEffect(() => {
    if (ethers && account) {
      setLoader(true);
      console.log();
      let addr = walletAddresses;
      let muobj = addr?.find((i) => {
        console.log(
          "iiiiiiiiii sososoos",
          i,
          i.toLowerCase() == account.toLowerCase()
        );
        // return i
        return i == account;
      });

      console.log("sososoos okokokok", muobj);
      setMyData(muobj);

      const leaves = addr?.map((x) => {
        console.log(x, "xxxxxxxxxxxxx");

        return ethers?.utils?.solidityKeccak256(["address"], [x]);
      });

      console.log("leavesleaves", leaves);

      const tree1 = new MerkleTree(leaves, keccak256, { sort: true });
      console.log("tree1", tree1);
      setTree(tree1);
      const proofs = leaves.map((leaf) => tree1?.getHexProof(leaf));
      const root = tree1.getHexRoot();

      console.log(proofs, "proofs");
      console.log(root, "root for contract");
      setRoot(root);
      if (tree1) {
        setLoader(false);
      }

      // Output the data to console or use set state functions here
      // console.log("tree", tree1);
      // console.log("leavesnode", proofs);
      // console.log("root", root);
    }
  }, [ethers, account]);
  // ======================================== Verify wallet address ====================================

  const images = [
    {
      original: "/assets/img1.svg",
      thumbnail: "/assets/img1.svg",
    },
    {
      original: "/assets/img2.svg",
      thumbnail: "/assets/img2.svg",
    },
    {
      original: "/assets/im3.svg",
      thumbnail: "/assets/im3.svg",
    },
    {
      original: "/assets/four.svg",
      thumbnail: "/assets/four.svg",
    },
    {
      original: "/assets/five.svg",
      thumbnail: "/assets/five.svg",
    },
    {
      original: "/assets/six.svg",
      thumbnail: "/assets/six.svg",
    },
    {
      original: "/assets/seven.svg",
      thumbnail: "/assets/seven.svg",
    },
    {
      original: "/assets/eight.svg",
      thumbnail: "/assets/eight.svg",
    },
    {
      original: "/assets/nine.svg",
      thumbnail: "/assets/nine.svg",
    },
    {
      original: "/assets/nine.svg",
      thumbnail: "/assets/nine.svg",
    },

    {
      original: "/assets/ten.svg",
      thumbnail: "/assets/ten.svg",
    },

    {
      original: "/assets/tenone.svg",
      thumbnail: "/assets/tenone.svg",
    },

    {
      original: "/assets/tentwo.svg",
      thumbnail: "/assets/tentwo.svg",
    },

    {
      original: "/assets/ten3.svg",
      thumbnail: "/assets/ten3.svg",
    },
  ];

  const moveNext = () => {
    navigate(`/Villaa`);
  };

  // ==================== Fetch NFT details =================
  const [nftPrice, setNftPrice] = useState(null);
  const [fetchMintedNFT, setfetchMintedNFT] = useState(null);

  const FetchHashHandle = async () => {
    const res = await FetchHashHook(1);
    console.log(res, "FetchHashHandle");

    setBaseURi(res);

    const etherValue = web3.utils.fromWei(res?.costPerNft, "ether");

    setNftPrice(etherValue);
    // console.log(res, "resssss in FetchHashHandle");
  };
  const [nftPriceWithCount, setNftPriceWithCount] = useState(null);
  console.log(
    nftPrice,
    "nftprriceeee",
    nftCount,
    nftCount * nftPrice,
    nftPriceWithCount?.toString(4)
  );

  const priceCount = () => {
    let priceCounttttt = nftCount * nftPrice;
    setNftPriceWithCount(priceCounttttt?.toFixed(4));
  };

  const FetchNftMintedHandle = async () => {
    const res = await fetchMintedNFThHook(1);
    console.log(res, "asdfasdfads");

    setfetchMintedNFT(res);
  };

  // ==================== Fetch NFT details =================

  // ==================== MINT FUN =================

  const [root, setRoot] = useState("");
  const [proof, setProof] = useState([]);
  const [verified, setVerified] = useState(false);
  console.log(proof, root, "datatatttttttt");

  const mintHandle = async () => {
    setLoader(true);
    let leave = null;
    console.log(myData, "myData", "account", account);

    if (account) {
      console.log("start buyinggg", account);

      if (myData) {
        console.log("buy nft with whitelist");

        leave = ethers.utils.solidityKeccak256(["address"], [myData]);

        // const proofs = await tree?.getHexProof(leave);
        const addressToCheck = account;
        const leaf = keccak256(addressToCheck);
        const proofData = tree.getHexProof(leave);
        setProof(proofData);

        try {
          console.log(baseUri?.costPerNft, nftCount, "before buyingg");
          setLoader(true);
          // Pass priceInWei to the BuyNFTHook
          const res = await BuyNFTHook(
            1,
            baseUri?.costPerNft,
            nftCount,
            proofData
          );

          console.log(res, "res in contract");
          await FetchNftMintedHandle();
          handleShow();
          setNftCount("");
          setLoader(false);
          toast?.success("Mint successfully");
        } catch (error) {
          console.log(error, "errrp");
          setLoader(false);
          toast?.error(error);
        }
      } else {
        console.log(
          baseUri?.costPerNft,
          nftCount,
          "before buyingg with public"
        );
        try {
          setLoader(true);
          // Pass priceInWei to the BuyNFTHook
          const res = await publicBuyNftHook(1, baseUri?.costPerNft, nftCount);

          console.log(res, "res in contract");
          await FetchNftMintedHandle();
          handleShow();
          setNftCount("");
          setLoader(false);
          toast?.success("Mint successfully");
        } catch (error) {
          console.log(error, "errrp");
          setLoader(false);
          toast?.error(error);
        }
      }
    } else {
      toast?.error("Please connect your wallet");
    }
  };

  // ==================== MINT FUN =================

  // ==================== Fetch NFT Data =================

  // const fetchMetadata = async () => {
  //   const BASE_URI = baseUri?.replace("ipfs://", "https://ipfs.io/ipfs/");

  //   try {
  //     setLoader(true);
  //     const response = await axios.get(`https://due-ever-anywhere-port.quicknode-ipfs.com/ipfs/QmZkgD5TC3rz7WPksobN9efqKub99mcNcfQwLNYokVjM1t/${id == 1 ? "vila.json" : "duplex.json"}`);
  //     console.log(response?.data, "ressssss");

  //     setMetadataArray(response.data[0]);
  //     setLoader(false);
  //   } catch (err) {
  //     console.log(err);
  //     setLoader(false);
  //   }
  // };

  // ==================== Fetch NFT Data =================

  useEffect(() => {
    FetchHashHandle();
    FetchNftMintedHandle();
  }, []);

  useEffect(() => {
    if (nftCount) {
      priceCount();
    }
  }, [nftCount]);

  // useEffect(() => {
  //   if (baseUri) {
  //     fetchMetadata();
  //   }
  // }, [id, baseUri]);

  // useEffect(() => {
  //   if (metadataArray?.gallery) {
  //     const images = metadataArray.gallery.map((item) => ({
  //       original: item?.image.replace("ipfs://", "https://ipfs.io/ipfs/"),
  //       thumbnail: item?.image.replace("ipfs://", "https://ipfs.io/ipfs/")
  //     }));
  //     setImages(images);
  //     console.log(images, "itemmmm imggggg");
  //   }
  // }, [metadataArray]);

  return (
    <>
      {loader && <Loader />}
      {show && (
        <Sucessmodal
          show={show}
          handleClose={handleClose}
          handleShow={handleShow}
        />
      )}
      <section className="Riyadh_vil">
        <Navbarmint />
        <div className="custom-container padingzero">
          <div className="  leftrightmarginonly_vil">
            <div className="row">
              <div className="col-xl-7 col-md-12 p-0">
                <div className="image-gallery-container">
                  {/* <img src='\assets\imggallery.svg' alt='img' className='img-fluid editimg' onClick={handleShow} /> */}
                  <ReactImageGallery items={images} className="h-100" />
                  {/* {
                    images &&
                  } */}
                </div>
              </div>
              <div className="col-xl-5 col-md-12  padingzero">
                <div className="right_side_villa">
                  <div className="outerdivleft_fst">
                    <div className="outerdivleft_iner">
                      <div className="outerdivleft_para">
                        <h1 className="mainhnd">
                          {/* {metadataArray?.name} */}
                          Duplex
                        </h1>
                        <p className="inerrara">
                          <span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M15.625 17.5H11.7609C12.41 16.9204 13.0222 16.3007 13.5938 15.6445C15.7383 13.1781 16.875 10.5781 16.875 8.125C16.875 6.30164 16.1507 4.55295 14.8614 3.26364C13.572 1.97433 11.8234 1.25 10 1.25C8.17664 1.25 6.42795 1.97433 5.13864 3.26364C3.84933 4.55295 3.125 6.30164 3.125 8.125C3.125 10.5781 4.25859 13.1781 6.40625 15.6445C6.97782 16.3007 7.58996 16.9204 8.23906 17.5H4.375C4.20924 17.5 4.05027 17.5658 3.93306 17.6831C3.81585 17.8003 3.75 17.9592 3.75 18.125C3.75 18.2908 3.81585 18.4497 3.93306 18.5669C4.05027 18.6842 4.20924 18.75 4.375 18.75H15.625C15.7908 18.75 15.9497 18.6842 16.0669 18.5669C16.1842 18.4497 16.25 18.2908 16.25 18.125C16.25 17.9592 16.1842 17.8003 16.0669 17.6831C15.9497 17.5658 15.7908 17.5 15.625 17.5ZM10 5.625C10.4945 5.625 10.9778 5.77162 11.3889 6.04633C11.8 6.32103 12.1205 6.71148 12.3097 7.16829C12.4989 7.62511 12.5484 8.12777 12.452 8.61273C12.3555 9.09768 12.1174 9.54314 11.7678 9.89277C11.4181 10.2424 10.9727 10.4805 10.4877 10.577C10.0028 10.6734 9.50011 10.6239 9.04329 10.4347C8.58648 10.2455 8.19603 9.92505 7.92133 9.51393C7.64662 9.1028 7.5 8.61945 7.5 8.125C7.5 7.46196 7.76339 6.82607 8.23223 6.35723C8.70107 5.88839 9.33696 5.625 10 5.625Z"
                                fill="#586F6B"
                              />
                            </svg>
                          </span>
                          {/* <span className="commonparaas">{metadataArray?.location}
                          Located in a residential area of the city of Doha 

                          </span> */}
                          <span className="commonparaas">
                            Located in a residential area of the city of Doha
                          </span>
                        </p>
                      </div>
                      <div className="outerdivleft_parasec">
                        <p className="commonparaas">Price</p>
                        <h4 className="commdig">
                          {/* {metadataArray?.price} */}
                          $700,000
                        </h4>
                      </div>
                    </div>
                    <div className="right_side w-100">
                      <div className="partsecond mb-4">
                        <button className="plusssdiv" onClick={decreseCount}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="9"
                            height="5"
                            viewBox="0 0 9 5"
                            fill="none"
                          >
                            <path
                              d="M8.46196 4.25H0.537964V0.75H8.46196V4.25Z"
                              fill="#10312B"
                            />
                          </svg>
                        </button>
                        <input
                          placeholder="0"
                          type="text"
                          className="inputmint"
                          value={nftCount}
                          onChange={(e) => handleInputChange(e)}
                        />
                        <button className="plusssdiv" onClick={increseCount}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="15"
                            viewBox="0 0 15 15"
                            fill="none"
                          >
                            <path
                              d="M5.73601 9.23606H0.640015V5.73606H5.73601V0.612061H9.26402V5.73606H14.36V9.23606H9.26402V14.3881H5.73601V9.23606Z"
                              fill="#10312B"
                            />
                          </svg>
                        </button>
                      </div>
                      {nftCount > baseUri?.maxMintAmount ? (
                        <p
                          className="text-danger mb-2"
                          style={{ fontWeight: "500", fontSize: "18px" }}
                        >
                          {/* You can't mint more than the max mint amount (max {baseUri?.maxMintAmount} per transaction). */}
                          {error}
                        </p>
                      ) : nftCount > baseUri?.maxSupply ? (
                        <p
                          className="text-danger mb-2"
                          style={{ fontWeight: "500", fontSize: "18px" }}
                        >
                          You can't mint more than the total max supply.
                        </p>
                      ) : null}

                      <div className="pirceinerdiv">
                        <div className="fstminbld">
                          <p className="mntgp">Price:</p>
                          <p className="mntgpcv">
                            {nftPriceWithCount ? nftPriceWithCount : nftPrice}{" "}
                            BNB
                          </p>
                        </div>
                        <div className="fstminbld">
                          <p className="mntgp ">Fraction:</p>
                          <p className="mntgpcv">
                            {fetchMintedNFT} /{" "}
                            <span className="muttedds">
                              {baseUri?.maxSupply}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                    {/* <button className="commonbtnorgss" onClick={() => mintHandle()}>Mint Your Estate Slice</button> */}
                    {nftCount > 0 &&
                    nftCount <= baseUri?.maxSupply &&
                    nftCount <= baseUri?.maxMintAmount ? (
                      <button
                        className="commonbtnorgss"
                        onClick={() => mintHandle()}
                      >
                        Login to Mint
                      </button>
                    ) : (
                      <button
                        className="commonbtnorgss disabled"
                        style={{ opacity: "0.5", cursor: "not-allowed" }}
                        disabled
                      >
                        Login to Mint
                      </button>
                    )}
                  </div>
                  <div className="outerdivleft_sec">
                    <div className="itofst">
                      <h4 className="inersechnd">Overview</h4>
                      <p className="commonparaas">
                        {/* {metadataArray?.description} */}
                        Experience luxury in this magnificent duplex located in
                        the heart of Doha, covering 700 m² of refined living
                        space. Designed for those who appreciate sophistication,
                        it offers unparalleled comfort and modern elegance.
                      </p>
                    </div>
                    <div className="icommnsa">
                      <div className="iconnsmaimdiv">
                        <p className="commonparaas_icon">Bathroom</p>
                        <p className="commonparaasdds">
                          <span className="">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M20.8557 12.9018H20.5933V5.63609C20.5968 4.96044 20.4099 4.29732 20.0539 3.72186C19.6978 3.1464 19.1868 2.6816 18.5787 2.38011C17.9706 2.07863 17.2898 1.9525 16.6134 2.01603C15.9369 2.07955 15.2919 2.33019 14.7513 2.73954C14.0161 2.4953 13.2154 2.5355 12.5087 2.85214C11.802 3.16879 11.2412 3.73862 10.9382 4.44806L10.8414 4.67645C10.7886 4.79822 10.7604 4.92916 10.7586 5.06177C10.7567 5.19438 10.7812 5.32605 10.8305 5.44924C10.8799 5.57244 10.9532 5.68474 11.0463 5.77972C11.1394 5.87469 11.2504 5.95048 11.373 6.00273L15.2359 7.65432C15.3626 7.70805 15.4989 7.73593 15.6366 7.73632C15.8349 7.73556 16.0286 7.6775 16.1943 7.56921C16.3599 7.46091 16.4903 7.30706 16.5696 7.12638L16.6678 6.89867C16.9379 6.28463 16.9971 5.59921 16.8362 4.94836C16.6753 4.29752 16.3033 3.7175 15.7777 3.29798C16.1779 3.09702 16.6233 3.00171 17.0711 3.0212C17.519 3.04069 17.9543 3.17433 18.3353 3.40928C18.7163 3.64423 19.0302 3.97261 19.2468 4.36291C19.4635 4.75321 19.5756 5.19233 19.5724 5.63812V12.9018H3.14496C2.84141 12.9022 2.55039 13.0223 2.33575 13.2357C2.12111 13.4492 2.00036 13.7386 2 14.0404V15.8025C2.00086 16.738 2.25768 17.6556 2.74295 18.4571C3.22823 19.2585 3.92366 19.9135 4.75472 20.3519L4.17815 21.1977C4.13881 21.2529 4.11095 21.3153 4.09618 21.3813C4.08141 21.4474 4.08004 21.5156 4.09214 21.5822C4.10425 21.6487 4.12959 21.7122 4.16668 21.7689C4.20377 21.8256 4.25186 21.8744 4.30814 21.9123C4.36442 21.9503 4.42775 21.9767 4.49443 21.99C4.56111 22.0034 4.62979 22.0033 4.69645 21.9899C4.76311 21.9765 4.82641 21.95 4.88264 21.912C4.93887 21.8739 4.9869 21.8251 5.02392 21.7684L5.72316 20.7437C6.19662 20.8833 6.6878 20.9545 7.18163 20.9551H16.8184C17.3119 20.9544 17.8028 20.8834 18.2762 20.7443L18.9747 21.7684C19.0117 21.8251 19.0598 21.8739 19.116 21.912C19.1722 21.95 19.2355 21.9765 19.3022 21.9899C19.3688 22.0033 19.4375 22.0034 19.5042 21.99C19.5709 21.9767 19.6342 21.9503 19.6905 21.9123C19.7468 21.8744 19.7949 21.8256 19.832 21.7689C19.869 21.7122 19.8944 21.6487 19.9065 21.5822C19.9186 21.5156 19.9172 21.4474 19.9025 21.3813C19.8877 21.3153 19.8598 21.2529 19.8205 21.1977L19.2439 20.3526C20.0753 19.9143 20.7711 19.2593 21.2566 18.4577C21.7422 17.6561 21.9991 16.7382 22 15.8025V14.0404C21.9996 13.7387 21.879 13.4494 21.6645 13.236C21.45 13.0225 21.1592 12.9024 20.8557 12.9018ZM15.7273 6.49475L15.6318 6.71636L11.7799 5.07562L11.8773 4.84859C12.0391 4.47626 12.3067 4.15902 12.6473 3.93581C12.9879 3.7126 13.3866 3.59315 13.7945 3.59211C14.0831 3.59256 14.3687 3.65183 14.6334 3.76628C15.1419 3.98433 15.5427 4.39406 15.7477 4.90558C15.9528 5.4171 15.9454 5.98862 15.7273 6.49475ZM20.975 15.8025C20.9732 16.8983 20.5346 17.9488 19.7554 18.7237C18.9761 19.4986 17.9197 19.9347 16.8177 19.9365H7.18163C6.0796 19.9347 5.02322 19.4986 4.24396 18.7237C3.46471 17.9488 3.02613 16.8983 3.02433 15.8025V14.0404C3.02433 14.0081 3.03726 13.977 3.06026 13.9541C3.08327 13.9313 3.11447 13.9184 3.147 13.9184H20.8557C20.8881 13.9186 20.9192 13.9315 20.942 13.9544C20.9649 13.9772 20.9777 14.0082 20.9777 14.0404L20.975 15.8025Z"
                                fill="#FF8A00"
                              />
                              <path
                                d="M9.82892 7.17904L9.13612 7.93263C9.03906 8.05095 8.99087 8.20189 9.00143 8.35456C9.01199 8.50723 9.08048 8.6501 9.1929 8.75394C9.30532 8.85777 9.45317 8.91473 9.6062 8.91315C9.75922 8.91156 9.90587 8.85157 10.0161 8.74543L10.7097 7.99184C10.8111 7.87361 10.8626 7.72064 10.8533 7.56519C10.8441 7.40973 10.7749 7.26394 10.6602 7.15853C10.5456 7.05313 10.3945 6.99636 10.2388 7.00018C10.0832 7.00401 9.93504 7.06813 9.82572 7.17904H9.82892ZM11.1865 9.75103C11.2581 9.78463 11.3356 9.80377 11.4146 9.80735C11.4936 9.81093 11.5725 9.79889 11.6468 9.77191C11.7211 9.74493 11.7894 9.70355 11.8477 9.65013C11.906 9.59672 11.9532 9.53232 11.9865 9.46063L12.3985 8.57583C12.4657 8.43156 12.4728 8.26651 12.4182 8.11701C12.3637 7.9675 12.252 7.84579 12.1077 7.77864C11.9634 7.71148 11.7984 7.70439 11.6489 7.75893C11.4994 7.81347 11.3777 7.92516 11.3105 8.06944L10.8985 8.95343C10.831 9.09741 10.8235 9.26228 10.8775 9.41183C10.9315 9.56138 11.0426 9.68338 11.1865 9.75103ZM13.3033 10.6742C13.4489 10.6741 13.5895 10.621 13.6988 10.5249C13.8082 10.4288 13.8789 10.2962 13.8977 10.1518L14.0297 9.13663C14.0501 8.97878 14.0069 8.8193 13.9097 8.69327C13.8125 8.56725 13.6692 8.485 13.5113 8.46463C13.3535 8.44427 13.194 8.48744 13.068 8.58466C12.9419 8.68188 12.8597 8.82518 12.8393 8.98303L12.7081 9.99744C12.698 10.0756 12.7034 10.155 12.724 10.2311C12.7446 10.3071 12.78 10.3784 12.8281 10.4408C12.8762 10.5032 12.9362 10.5555 13.0046 10.5948C13.0729 10.634 13.1483 10.6594 13.2265 10.6694C13.252 10.6726 13.2776 10.6742 13.3033 10.6742Z"
                                fill="#FF8A00"
                              />
                            </svg>
                          </span>
                          {/* {metadataArray?.features?.bedrooms} */}
                          10
                        </p>
                      </div>
                      <div className="iconnsmaimdiv">
                        <p className="commonparaas_icon">Bedroom</p>
                        <p className="commonparaasdds">
                          <span className="">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M22.2266 11.12V7.23599C22.2255 6.2478 21.8325 5.30039 21.1338 4.60163C20.435 3.90287 19.4876 3.50985 18.4994 3.50879H5.485C4.49722 3.51048 3.55042 3.90379 2.85219 4.60248C2.15395 5.30116 1.76125 6.24821 1.7602 7.23599V11.1288C1.29568 11.343 0.902044 11.6855 0.625664 12.116C0.349284 12.5464 0.201666 13.0469 0.200195 13.5584V17.9648C0.200619 18.2771 0.324933 18.5765 0.545857 18.7973C0.766781 19.0181 1.06627 19.1422 1.3786 19.1424H2.7466V19.8912C2.7466 20.0503 2.80981 20.2029 2.92233 20.3155C3.03485 20.428 3.18747 20.4912 3.3466 20.4912C3.50573 20.4912 3.65834 20.428 3.77086 20.3155C3.88338 20.2029 3.9466 20.0503 3.9466 19.8912V19.1424H20.0546V19.8912C20.0546 20.0503 20.1178 20.2029 20.2303 20.3155C20.3429 20.428 20.4955 20.4912 20.6546 20.4912C20.8137 20.4912 20.9663 20.428 21.0789 20.3155C21.1914 20.2029 21.2546 20.0503 21.2546 19.8912V19.1424H22.6226C22.9348 19.142 23.2341 19.0178 23.4548 18.797C23.6756 18.5763 23.7998 18.277 23.8002 17.9648V13.5584C23.799 13.0439 23.6501 12.5406 23.3711 12.1083C23.0922 11.6761 22.6949 11.333 22.2266 11.12ZM2.9602 7.23599C2.96083 6.56634 3.22696 5.92427 3.70025 5.45054C4.17353 4.9768 4.81535 4.71006 5.485 4.70879H18.4994C19.1695 4.70942 19.8119 4.97589 20.2857 5.44969C20.7595 5.9235 21.026 6.56593 21.0266 7.23599V10.8704H19.101V9.19039C19.1006 8.63773 18.8809 8.10782 18.4902 7.71696C18.0995 7.3261 17.5697 7.10622 17.017 7.10559H14.6642C14.1115 7.10622 13.5816 7.32608 13.1907 7.71691C12.7999 8.10775 12.58 8.63766 12.5794 9.19039V10.8704H11.4138V9.19039C11.4132 8.63766 11.1933 8.10775 10.8025 7.71691C10.4116 7.32608 9.88172 7.10622 9.329 7.10559H6.9754C6.4235 7.10749 5.89482 7.3279 5.50502 7.71861C5.11522 8.10931 4.89603 8.63849 4.8954 9.19039V10.8704H2.9602V7.23599ZM17.9034 10.8704H13.7794V9.19039C13.7796 8.95579 13.8729 8.73086 14.0388 8.56497C14.2047 8.39909 14.4296 8.3058 14.6642 8.30559H17.017C17.2515 8.3058 17.4764 8.39911 17.6421 8.56502C17.8079 8.73093 17.901 8.95586 17.901 9.19039L17.9034 10.8704ZM10.2162 10.8704H6.0914V9.19039C6.0916 8.95662 6.18423 8.73241 6.34908 8.56666C6.51393 8.40091 6.73763 8.30707 6.9714 8.30559H9.325C9.55959 8.3058 9.78452 8.39909 9.95041 8.56497C10.1163 8.73086 10.2096 8.95579 10.2098 9.19039L10.2162 10.8704ZM20.6642 17.9448H20.6546H20.6442L3.4442 17.9624C3.41231 17.9529 3.37965 17.9462 3.3466 17.9424C3.31302 17.9462 3.27983 17.9529 3.2474 17.9624H1.4002V13.5584C1.40062 13.1639 1.55753 12.7856 1.83649 12.5067C2.11545 12.2277 2.49368 12.0708 2.8882 12.0704H21.1122C21.5067 12.0708 21.8849 12.2277 22.1639 12.5067C22.4429 12.7856 22.5998 13.1639 22.6002 13.5584L22.6226 17.9424L20.6642 17.9448Z"
                                fill="#FF8A00"
                              />
                            </svg>
                          </span>
                          8{/* {metadataArray?.features?.bathrooms} */}
                        </p>
                      </div>
                      <div className="iconnsmaimdiv">
                        <p className="commonparaas_icon">Area Space</p>
                        <p className="commonparaasdds">
                          <span className="">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M6.28543 2.47571C6.28543 2.21187 6.07156 2 5.80971 2H2.47571C2.21187 2 2 2.21387 2 2.47571V5.80971C2 6.07356 2.21387 6.28543 2.47571 6.28543C2.73756 6.28543 2.95143 6.07156 2.95143 5.80971V2.95343H5.80772C6.07156 2.95343 6.28343 2.73956 6.28343 2.47771L6.28543 2.47571ZM17.7146 21.5243C17.7146 21.7881 17.9284 22 18.1903 22H21.5243C21.7881 22 22 21.7861 22 21.5243V18.1903C22 17.9264 21.7861 17.7146 21.5243 17.7146C21.2624 17.7146 21.0486 17.9284 21.0486 18.1903V21.0466H18.1923C17.9284 21.0466 17.7166 21.2604 17.7166 21.5223L17.7146 21.5243Z"
                                fill="#FF8A00"
                              />
                              <path
                                d="M20 18.5297V4.46832C20 4.20858 19.7754 4 19.5005 4H4.49954C4.22248 4 4 4.21055 4 4.46832V18.5317C4 18.7914 4.22458 19 4.49954 19H19.5005C19.7775 19 20 18.7895 20 18.5317V18.5297ZM19.0009 18.0614H4.99908V4.93664H18.9988V18.0614H19.0009Z"
                                fill="#FF8A00"
                              />
                              <path
                                d="M8.48725 13.9982C8.81209 13.9982 8.97451 13.85 8.97451 13.5518V12.0534C8.97451 11.7698 9.0476 11.5485 9.19174 11.3875C9.33589 11.2265 9.53485 11.146 9.7866 11.146C10.0079 11.146 10.1663 11.2064 10.2617 11.3271C10.3571 11.4479 10.4058 11.6381 10.4058 11.8997V13.5518C10.4058 13.85 10.5682 13.9982 10.8931 13.9982C11.2179 13.9982 11.3722 13.85 11.3722 13.5518V12.0534C11.3722 11.7698 11.4433 11.5485 11.5894 11.3875C11.7336 11.2265 11.9326 11.146 12.1843 11.146C12.4117 11.146 12.5721 11.2064 12.6675 11.3271C12.7629 11.4479 12.8096 11.6381 12.8096 11.8997V13.5518C12.8096 13.85 12.97 13.9982 13.2887 13.9982C13.6075 13.9982 13.776 13.85 13.776 13.5518V11.865C13.776 10.9301 13.3497 10.4636 12.499 10.4636C12.2148 10.4636 11.963 10.5221 11.7397 10.6411C11.5184 10.76 11.3478 10.9228 11.2301 11.1332C11.0555 10.6868 10.684 10.4636 10.1155 10.4636C9.85157 10.4636 9.62012 10.5166 9.41913 10.6209C9.21814 10.7252 9.05978 10.8716 8.94609 11.0563V10.9173C8.94609 10.6246 8.78976 10.4782 8.47304 10.4782C8.15633 10.4782 8 10.6246 8 10.9173V13.5536C8 13.8518 8.16039 14 8.47913 14L8.48725 13.9982ZM14.7282 9.75192C14.8033 9.7757 14.8865 9.7629 14.9799 9.71716C15.0632 9.67508 15.1505 9.64215 15.2439 9.61654C15.3372 9.59093 15.4266 9.57812 15.5139 9.57812C15.8123 9.57812 15.9626 9.69887 15.9626 9.94036C15.9626 10.0373 15.9362 10.1361 15.8813 10.2331C15.8265 10.33 15.7352 10.4398 15.6073 10.5606L14.8256 11.2997C14.7627 11.3546 14.714 11.4113 14.6794 11.4662C14.6429 11.5229 14.6246 11.5869 14.6246 11.6619C14.6246 11.7552 14.6591 11.8302 14.7282 11.8888C14.7972 11.9473 14.8845 11.9766 14.988 11.9766H16.667C16.8883 11.9766 17 11.8796 17 11.6839C17 11.4881 16.8883 11.3911 16.667 11.3911H15.6073L16.2813 10.7636C16.4661 10.5917 16.6 10.4343 16.6792 10.2898C16.7584 10.1453 16.799 9.99707 16.799 9.8434C16.799 9.58361 16.6995 9.37687 16.5006 9.22686C16.3016 9.07684 16.0316 9 15.6925 9C15.522 9 15.3494 9.02012 15.1748 9.05854C15.0002 9.09879 14.8439 9.15551 14.7099 9.22869C14.6165 9.27991 14.5597 9.34211 14.5394 9.41712C14.5191 9.49213 14.5272 9.55982 14.5617 9.62203C14.5982 9.68423 14.6531 9.72814 14.7282 9.75009V9.75192Z"
                                fill="#FF8A00"
                              />
                            </svg>
                          </span>
                          {/* {metadataArray?.size} */}
                          700m2
                        </p>
                      </div>
                      <div className="iconnsmaimdiv">
                        <p className="commonparaas_icon">Annual Return</p>
                        <p className="commonparaasdds">
                          <span className="">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M14 3H20.6667C21.4027 3 22 3.59733 22 4.33333V5H14V4.33333C14 3.59733 14.736 3 14 3Z"
                                fill="white"
                              />
                              <path
                                d="M6 13.3333V4.33333C6 3.59733 6.57018 3 7.27273 3H20C19.2975 3 18.7273 3.59733 18.7273 4.33333V19.6667C18.7273 20.4027 18.1571 21 17.4545 21H6V20V13.3333Z"
                                fill="white"
                              />
                              <path
                                d="M18 21H3.3913C2.6233 21 2 20.4027 2 19.6667V19H16.6087V19.6667C16.6087 20.4027 17.232 21 18 21Z"
                                fill="white"
                              />
                              <path
                                d="M21.6667 5.33271C21.8507 5.33271 22.0001 5.18336 22.0001 4.99935V4.33261C22.0001 3.41318 21.2527 2.66577 20.3332 2.66577H13.6659C13.4819 2.66577 13.3325 2.81512 13.3325 2.99914C13.3325 3.18316 13.4819 3.33251 13.6659 3.33251H20.3332C20.8846 3.33251 21.3333 3.78122 21.3333 4.33261V4.99935C21.3333 5.18336 21.4827 5.33271 21.6667 5.33271Z"
                                fill="#FF8A00"
                              />
                              <path
                                d="M16.4994 20.6676H17.6661C18.2175 20.6676 18.6662 20.2189 18.6662 19.6675V4.33261C18.6662 3.95724 18.7909 3.6112 19.0003 3.33251H6.99838C6.44699 3.33251 5.99828 3.78122 5.99828 4.33261V7.66629C5.99828 7.85031 5.84893 7.99965 5.66491 7.99965C5.48089 7.99965 5.33154 7.85031 5.33154 7.66629V4.33261C5.33154 3.41318 6.07895 2.66577 6.99838 2.66577H20.3331C20.5171 2.66577 20.6665 2.81512 20.6665 2.99914C20.6665 3.18316 20.5171 3.33251 20.3331 3.33251C19.7817 3.33251 19.333 3.78122 19.333 4.33261V19.6675C19.333 20.5869 18.5856 21.3344 17.6661 21.3344H16.4994V20.6676Z"
                                fill="#FF8A00"
                              />
                              <path
                                d="M1.99805 19.6676V19.0008C1.99805 18.8168 2.1474 18.6675 2.33141 18.6675H16.3329C16.5169 18.6675 16.6662 18.8168 16.6662 19.0008V19.6676C16.6662 20.219 17.1149 20.6677 17.6663 20.6677C17.8503 20.6677 17.9997 20.817 17.9997 21.001C17.9997 21.1851 17.8503 21.3344 17.6663 21.3344H3.66489C2.74546 21.3344 1.99805 20.587 1.99805 19.6676ZM15.9995 19.6676V19.3342H2.66478V19.6676C2.66478 20.219 3.1135 20.6677 3.66489 20.6677H16.3335C16.1242 20.389 15.9995 20.0429 15.9995 19.6676ZM10.999 9.99991H11.6657C11.8497 9.99991 11.9991 9.85056 11.9991 9.66654C11.9991 9.48252 11.8497 9.33318 11.6657 9.33318H10.999C10.815 9.33318 10.6656 9.48252 10.6656 9.66654C10.6656 9.85056 10.815 9.99991 10.999 9.99991ZM12.9992 9.99991H13.6659C13.8499 9.99991 13.9993 9.85056 13.9993 9.66654C13.9993 9.48252 13.8499 9.33318 13.6659 9.33318H12.9992C12.8152 9.33318 12.6658 9.48252 12.6658 9.66654C12.6658 9.85056 12.8152 9.99991 12.9992 9.99991ZM14.9994 9.99991H16.9996C17.1836 9.99991 17.333 9.85056 17.333 9.66654C17.333 9.48252 17.1836 9.33318 16.9996 9.33318H14.9994C14.8154 9.33318 14.666 9.48252 14.666 9.66654C14.666 9.85056 14.8154 9.99991 14.9994 9.99991ZM13.6659 11.3334H16.9996C17.1836 11.3334 17.333 11.184 17.333 11C17.333 10.816 17.1836 10.6666 16.9996 10.6666H13.6659C13.4819 10.6666 13.3325 10.816 13.3325 11C13.3325 11.184 13.4819 11.3334 13.6659 11.3334ZM13.6659 8.66644H16.9996C17.1836 8.66644 17.333 8.51709 17.333 8.33307C17.333 8.14905 17.1836 7.99971 16.9996 7.99971H13.6659C13.4819 7.99971 13.3325 8.14905 13.3325 8.33307C13.3325 8.51709 13.4819 8.66644 13.6659 8.66644ZM11.6657 8.66644H12.3324C12.5165 8.66644 12.6658 8.51709 12.6658 8.33307C12.6658 8.14905 12.5165 7.99971 12.3324 7.99971H11.6657C11.4817 7.99971 11.3323 8.14905 11.3323 8.33307C11.3323 8.51709 11.4817 8.66644 11.6657 8.66644ZM9.6655 8.66644H10.3322C10.5163 8.66644 10.6656 8.51709 10.6656 8.33307C10.6656 8.14905 10.5163 7.99971 10.3322 7.99971H9.6655C9.48148 7.99971 9.33214 8.14905 9.33214 8.33307C9.33214 8.51709 9.48148 8.66644 9.6655 8.66644ZM10.999 7.33297H13.6659C13.8499 7.33297 13.9993 7.18362 13.9993 6.9996C13.9993 6.81558 13.8499 6.66623 13.6659 6.66623H10.999C10.815 6.66623 10.6656 6.81558 10.6656 6.9996C10.6656 7.18362 10.815 7.33297 10.999 7.33297ZM7.6653 7.33297H9.6655C9.84952 7.33297 9.99887 7.18362 9.99887 6.9996C9.99887 6.81558 9.84952 6.66623 9.6655 6.66623H7.6653C7.48128 6.66623 7.33193 6.81558 7.33193 6.9996C7.33193 7.18362 7.48128 7.33297 7.6653 7.33297ZM14.9994 7.33297H16.9996C17.1836 7.33297 17.333 7.18362 17.333 6.9996C17.333 6.81558 17.1836 6.66623 16.9996 6.66623H14.9994C14.8154 6.66623 14.666 6.81558 14.666 6.9996C14.666 7.18362 14.8154 7.33297 14.9994 7.33297ZM7.6653 5.9995H10.999C11.183 5.9995 11.3323 5.85015 11.3323 5.66613C11.3323 5.48211 11.183 5.33276 10.999 5.33276H7.6653C7.48128 5.33276 7.33193 5.48211 7.33193 5.66613C7.33193 5.85015 7.48128 5.9995 7.6653 5.9995ZM12.3324 5.9995H12.9992C13.1832 5.9995 13.3325 5.85015 13.3325 5.66613C13.3325 5.48211 13.1832 5.33276 12.9992 5.33276H12.3324C12.1484 5.33276 11.9991 5.48211 11.9991 5.66613C11.9991 5.85015 12.1484 5.9995 12.3324 5.9995ZM14.3327 5.9995H16.9996C17.1836 5.9995 17.333 5.85015 17.333 5.66613C17.333 5.48211 17.1836 5.33276 16.9996 5.33276H14.3327C14.1486 5.33276 13.9993 5.48211 13.9993 5.66613C13.9993 5.85015 14.1486 5.9995 14.3327 5.9995Z"
                                fill="#FF8A00"
                              />
                              <path
                                d="M6.99851 9.33374C6.53513 9.33374 6.08775 9.40375 5.66504 9.52976V13.3335V18.472C6.08775 18.598 6.53513 18.668 6.99851 18.668C9.57544 18.668 11.6657 16.5778 11.6657 14.0009C11.6657 11.424 9.57544 9.33374 6.99851 9.33374Z"
                                fill="white"
                              />
                              <path
                                d="M6.66532 17.668C9.0588 17.668 10.9991 15.7277 10.9991 13.3343C10.9991 10.9408 9.0588 9.00049 6.66532 9.00049C4.27184 9.00049 2.33154 10.9408 2.33154 13.3343C2.33154 15.7277 4.27184 17.668 6.66532 17.668Z"
                                fill="white"
                              />
                              <path
                                d="M7.33183 9.6665C4.93891 9.6665 2.99805 11.6074 2.99805 14.001C2.99805 15.0277 3.35742 15.9698 3.95415 16.7126C4.69689 17.31 5.63899 17.6687 6.66509 17.6687C9.058 17.6687 10.9989 15.7278 10.9989 13.3342C10.9989 12.3074 10.6395 11.3653 10.0428 10.6226C9.30003 10.0252 8.35793 9.6665 7.33183 9.6665Z"
                                fill="white"
                              />
                              <path
                                d="M6.64689 18.0107C5.40142 18.0107 4.2313 17.5266 3.35255 16.6472C1.80305 15.0984 1.53703 12.7175 2.70715 10.8586C2.80516 10.7026 3.01118 10.6572 3.16653 10.7539C3.32188 10.8519 3.36922 11.0579 3.27054 11.2133C2.26777 12.8075 2.49513 14.8483 3.82326 16.1758C4.57667 16.9292 5.57944 17.3439 6.64622 17.3439C6.64889 17.3439 6.65155 17.3439 6.65489 17.3439C7.72566 17.3419 8.73377 16.9226 9.49318 16.1631C10.2526 15.4037 10.672 14.3963 10.674 13.3248C10.676 12.2541 10.2613 11.2486 9.50585 10.4932C8.18971 9.17642 6.09416 8.95107 4.52067 9.95517C4.36532 10.0525 4.1593 10.0098 4.05995 9.85383C3.96128 9.69848 4.00661 9.49245 4.1613 9.39378C5.99615 8.22232 8.4424 8.48635 9.97723 10.0225C10.8587 10.9039 11.3434 12.0774 11.3407 13.3268C11.338 14.5756 10.8493 15.7504 9.96456 16.6352C9.0798 17.5199 7.90502 18.0093 6.65622 18.0113C6.65289 18.0107 6.65022 18.0107 6.64689 18.0107Z"
                                fill="#FF8A00"
                              />
                              <path
                                d="M6.66515 16.0011C7.59991 16.0011 8.33198 15.269 8.33198 14.3343C8.33198 13.5775 7.81793 13.0261 6.80449 12.6954L6.72915 12.6708C6.34911 12.5468 5.99841 12.3801 5.99841 12.0007C5.99841 11.608 6.27244 11.334 6.66515 11.334C7.13453 11.334 7.44789 11.586 7.45056 11.5887C7.59257 11.7073 7.80193 11.6887 7.92061 11.5487C8.03929 11.4073 8.02062 11.198 7.87994 11.0793C7.85993 11.0626 7.38255 10.6672 6.66515 10.6672C5.9044 10.6672 5.33167 11.2406 5.33167 12.0007C5.33167 12.9168 6.22777 13.2095 6.5218 13.3042L6.59714 13.3288C7.31655 13.5635 7.66525 13.8929 7.66525 14.3343C7.66525 14.9043 7.2352 15.3344 6.66515 15.3344C6.04641 15.3344 5.69238 14.9263 5.59837 14.801C5.48769 14.653 5.27834 14.6243 5.13165 14.7337C4.98364 14.8443 4.95364 15.053 5.06431 15.2004C5.20566 15.3891 5.73705 16.0011 6.66515 16.0011Z"
                                fill="#FF8A00"
                              />
                              <path
                                d="M6.66491 16.6678C6.84893 16.6678 6.99828 16.5185 6.99828 16.3345V16.0011C6.99828 15.8171 6.84893 15.6677 6.66491 15.6677C6.48089 15.6677 6.33154 15.8171 6.33154 16.0011V16.3345C6.33154 16.5185 6.48089 16.6678 6.66491 16.6678ZM6.66491 11.0006C6.84893 11.0006 6.99828 10.8512 6.99828 10.6672V10.3339C6.99828 10.1498 6.84893 10.0005 6.66491 10.0005C6.48089 10.0005 6.33154 10.1498 6.33154 10.3339V10.6672C6.33154 10.8512 6.48089 11.0006 6.66491 11.0006Z"
                                fill="#FF8A00"
                              />
                            </svg>
                          </span>
                          {/* {metadataArray?.size} */}
                          8-10%
                        </p>
                      </div>
                    </div>
                    <hr className="center_line"></hr>

                    <div className="gerala_div">
                      <h4 className="inersechnd">General Information</h4>
                      <ul className="ullliiss">
                        {/* {
                          metadataArray?.GeneralInformation?.map((item, index) => {
                            console.log(item, "itemmmmmmmmm");
                            return (
                              <li className="fordesign" key={index}>
                                {item?.item}
                              </li>
                            )
                          })
                        } */}

                        <li className="fordesign">
                          8 elegant bedrooms, including a 120 m² master suite
                          with a sitting area and private bath.
                        </li>
                        <li className="fordesign">
                          A state-of-the-art 50 m² gourmet kitchen with granite
                          countertops and modern appliances.
                        </li>
                        <li className="fordesign">
                          2 spacious living rooms and a formal dining room
                          perfect for entertaining.
                        </li>
                        <li className="fordesign">
                          Luxurious bathrooms with contemporary fixtures,
                          including rain showers.
                        </li>
                        <li className="fordesign">
                          Abundant natural light and stunning views of Doha from
                          large picture windows.
                        </li>
                      </ul>
                    </div>
                    {/* <hr className="center_line"></hr>
                    <div className="gerala_div">
                      <h4 className="inersechnd">
                        Interior Details
                      </h4>
                      <ul className="ullliiss">
                        {
                          metadataArray?.InteriorDetails?.map((item, index) => {
                            return (
                              <li className="fordesign" key={index}>
                                {item?.item}
                              </li>
                            )
                          })
                        }
                      </ul>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="Riyadh_vil_btmm">
        <div className="custom-container  ">
          <div className="row">
            <div className="col-xl-12 col-md-11 ">
              <h1 className="mainhnd">Villa</h1>
              <div className="ourteammainouter_divvilla">
                <div
                  className="maincarddiv"
                  onClick={() => moveNext()}
                  style={{ cursor: "pointer" }}
                >
                  {/* <button className="rentbutton">For Rent</button> */}
                  <div className="zoom-container">
                    <img
                      src="\assets\ourteam\villa.jpg"
                      className="imgcardddds"
                    />
                  </div>
                  <div className="inercard_dta">
                    <div className="d-flex justify-content-between">
                      <h1> Villa</h1>
                      <h3> $500,000</h3>
                    </div>
                    <p>Located in a residential area of the city of Riyadh</p>
                    <div className="iner_mainsssss">
                      <div className="cardds">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M6.28543 2.47571C6.28543 2.21187 6.07156 2 5.80971 2H2.47571C2.21187 2 2 2.21387 2 2.47571V5.80971C2 6.07356 2.21387 6.28543 2.47571 6.28543C2.73756 6.28543 2.95143 6.07156 2.95143 5.80971V2.95343H5.80772C6.07156 2.95343 6.28343 2.73956 6.28343 2.47771L6.28543 2.47571ZM17.7146 21.5243C17.7146 21.7881 17.9284 22 18.1903 22H21.5243C21.7881 22 22 21.7861 22 21.5243V18.1903C22 17.9264 21.7861 17.7146 21.5243 17.7146C21.2624 17.7146 21.0486 17.9284 21.0486 18.1903V21.0466H18.1923C17.9284 21.0466 17.7166 21.2604 17.7166 21.5223L17.7146 21.5243Z"
                            fill="#FF8A00"
                          />
                          <path
                            d="M20 18.5297V4.46832C20 4.20858 19.7754 4 19.5005 4H4.49954C4.22248 4 4 4.21055 4 4.46832V18.5317C4 18.7914 4.22458 19 4.49954 19H19.5005C19.7775 19 20 18.7895 20 18.5317V18.5297ZM19.0009 18.0614H4.99908V4.93664H18.9988V18.0614H19.0009Z"
                            fill="#FF8A00"
                          />
                          <path
                            d="M8.48725 13.9982C8.81209 13.9982 8.97451 13.85 8.97451 13.5518V12.0534C8.97451 11.7698 9.0476 11.5485 9.19174 11.3875C9.33589 11.2265 9.53485 11.146 9.7866 11.146C10.0079 11.146 10.1663 11.2064 10.2617 11.3271C10.3571 11.4479 10.4058 11.6381 10.4058 11.8997V13.5518C10.4058 13.85 10.5682 13.9982 10.8931 13.9982C11.2179 13.9982 11.3722 13.85 11.3722 13.5518V12.0534C11.3722 11.7698 11.4433 11.5485 11.5894 11.3875C11.7336 11.2265 11.9326 11.146 12.1843 11.146C12.4117 11.146 12.5721 11.2064 12.6675 11.3271C12.7629 11.4479 12.8096 11.6381 12.8096 11.8997V13.5518C12.8096 13.85 12.97 13.9982 13.2887 13.9982C13.6075 13.9982 13.776 13.85 13.776 13.5518V11.865C13.776 10.9301 13.3497 10.4636 12.499 10.4636C12.2148 10.4636 11.963 10.5221 11.7397 10.6411C11.5184 10.76 11.3478 10.9228 11.2301 11.1332C11.0555 10.6868 10.684 10.4636 10.1155 10.4636C9.85157 10.4636 9.62012 10.5166 9.41913 10.6209C9.21814 10.7252 9.05978 10.8716 8.94609 11.0563V10.9173C8.94609 10.6246 8.78976 10.4782 8.47304 10.4782C8.15633 10.4782 8 10.6246 8 10.9173V13.5536C8 13.8518 8.16039 14 8.47913 14L8.48725 13.9982ZM14.7282 9.75192C14.8033 9.7757 14.8865 9.7629 14.9799 9.71716C15.0632 9.67508 15.1505 9.64215 15.2439 9.61654C15.3372 9.59093 15.4266 9.57812 15.5139 9.57812C15.8123 9.57812 15.9626 9.69887 15.9626 9.94036C15.9626 10.0373 15.9362 10.1361 15.8813 10.2331C15.8265 10.33 15.7352 10.4398 15.6073 10.5606L14.8256 11.2997C14.7627 11.3546 14.714 11.4113 14.6794 11.4662C14.6429 11.5229 14.6246 11.5869 14.6246 11.6619C14.6246 11.7552 14.6591 11.8302 14.7282 11.8888C14.7972 11.9473 14.8845 11.9766 14.988 11.9766H16.667C16.8883 11.9766 17 11.8796 17 11.6839C17 11.4881 16.8883 11.3911 16.667 11.3911H15.6073L16.2813 10.7636C16.4661 10.5917 16.6 10.4343 16.6792 10.2898C16.7584 10.1453 16.799 9.99707 16.799 9.8434C16.799 9.58361 16.6995 9.37687 16.5006 9.22686C16.3016 9.07684 16.0316 9 15.6925 9C15.522 9 15.3494 9.02012 15.1748 9.05854C15.0002 9.09879 14.8439 9.15551 14.7099 9.22869C14.6165 9.27991 14.5597 9.34211 14.5394 9.41712C14.5191 9.49213 14.5272 9.55982 14.5617 9.62203C14.5982 9.68423 14.6531 9.72814 14.7282 9.75009V9.75192Z"
                            fill="#FF8A00"
                          />
                        </svg>
                        <h2>500m2</h2>
                      </div>
                      <div className="cardds">
                        <svg
                          className="imgsvgss"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M22.2266 11.12V7.23599C22.2255 6.2478 21.8325 5.30039 21.1338 4.60163C20.435 3.90287 19.4876 3.50985 18.4994 3.50879H5.485C4.49722 3.51048 3.55042 3.90379 2.85219 4.60248C2.15395 5.30116 1.76125 6.24821 1.7602 7.23599V11.1288C1.29568 11.343 0.902044 11.6855 0.625664 12.116C0.349284 12.5464 0.201666 13.0469 0.200195 13.5584V17.9648C0.200619 18.2771 0.324933 18.5765 0.545857 18.7973C0.766781 19.0181 1.06627 19.1422 1.3786 19.1424H2.7466V19.8912C2.7466 20.0503 2.80981 20.2029 2.92233 20.3155C3.03485 20.428 3.18747 20.4912 3.3466 20.4912C3.50573 20.4912 3.65834 20.428 3.77086 20.3155C3.88338 20.2029 3.9466 20.0503 3.9466 19.8912V19.1424H20.0546V19.8912C20.0546 20.0503 20.1178 20.2029 20.2303 20.3155C20.3429 20.428 20.4955 20.4912 20.6546 20.4912C20.8137 20.4912 20.9663 20.428 21.0789 20.3155C21.1914 20.2029 21.2546 20.0503 21.2546 19.8912V19.1424H22.6226C22.9348 19.142 23.2341 19.0178 23.4548 18.797C23.6756 18.5763 23.7998 18.277 23.8002 17.9648V13.5584C23.799 13.0439 23.6501 12.5406 23.3711 12.1083C23.0922 11.6761 22.6949 11.333 22.2266 11.12ZM2.9602 7.23599C2.96083 6.56634 3.22696 5.92427 3.70025 5.45054C4.17353 4.9768 4.81535 4.71006 5.485 4.70879H18.4994C19.1695 4.70942 19.8119 4.97589 20.2857 5.44969C20.7595 5.9235 21.026 6.56593 21.0266 7.23599V10.8704H19.101V9.19039C19.1006 8.63773 18.8809 8.10782 18.4902 7.71696C18.0995 7.3261 17.5697 7.10622 17.017 7.10559H14.6642C14.1115 7.10622 13.5816 7.32608 13.1907 7.71691C12.7999 8.10775 12.58 8.63766 12.5794 9.19039V10.8704H11.4138V9.19039C11.4132 8.63766 11.1933 8.10775 10.8025 7.71691C10.4116 7.32608 9.88172 7.10622 9.329 7.10559H6.9754C6.4235 7.10749 5.89482 7.3279 5.50502 7.71861C5.11522 8.10931 4.89603 8.63849 4.8954 9.19039V10.8704H2.9602V7.23599ZM17.9034 10.8704H13.7794V9.19039C13.7796 8.95579 13.8729 8.73086 14.0388 8.56497C14.2047 8.39909 14.4296 8.3058 14.6642 8.30559H17.017C17.2515 8.3058 17.4764 8.39911 17.6421 8.56502C17.8079 8.73093 17.901 8.95586 17.901 9.19039L17.9034 10.8704ZM10.2162 10.8704H6.0914V9.19039C6.0916 8.95662 6.18423 8.73241 6.34908 8.56666C6.51393 8.40091 6.73763 8.30707 6.9714 8.30559H9.325C9.55959 8.3058 9.78452 8.39909 9.95041 8.56497C10.1163 8.73086 10.2096 8.95579 10.2098 9.19039L10.2162 10.8704ZM20.6642 17.9448H20.6546H20.6442L3.4442 17.9624C3.41231 17.9529 3.37965 17.9462 3.3466 17.9424C3.31302 17.9462 3.27983 17.9529 3.2474 17.9624H1.4002V13.5584C1.40062 13.1639 1.55753 12.7856 1.83649 12.5067C2.11545 12.2277 2.49368 12.0708 2.8882 12.0704H21.1122C21.5067 12.0708 21.8849 12.2277 22.1639 12.5067C22.4429 12.7856 22.5998 13.1639 22.6002 13.5584L22.6226 17.9424L20.6642 17.9448Z"
                            fill="#FF8A00"
                          />
                        </svg>
                        <h2> 5</h2>
                      </div>
                      <div className="cardds">
                        <svg
                          className="imgsvgss"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_87_352)">
                            <path
                              d="M22.3953 13.0697H22.0873V4.49287C22.0914 3.6953 21.872 2.91253 21.4541 2.23324C21.0361 1.55394 20.4363 1.00527 19.7225 0.649386C19.0087 0.293498 18.2095 0.144614 17.4155 0.219602C16.6214 0.29459 15.8643 0.590452 15.2297 1.07367C14.3667 0.78535 13.4268 0.83281 12.5972 1.20659C11.7677 1.58037 11.1095 2.25302 10.7537 3.09047L10.6401 3.36007C10.5781 3.50382 10.5451 3.65838 10.5429 3.81492C10.5407 3.97146 10.5694 4.12689 10.6274 4.27231C10.6853 4.41774 10.7714 4.5503 10.8807 4.66241C10.9899 4.77453 11.1202 4.86399 11.2641 4.92567L15.7985 6.87527C15.9473 6.93869 16.1072 6.97161 16.2689 6.97207C16.5016 6.97117 16.7291 6.90264 16.9235 6.7748C17.118 6.64697 17.271 6.46535 17.3641 6.25207L17.4793 5.98327C17.7964 5.25844 17.8659 4.44934 17.6771 3.68105C17.4882 2.91277 17.0515 2.22809 16.4345 1.73287C16.9043 1.49565 17.4271 1.38315 17.9528 1.40615C18.4786 1.42916 18.9896 1.58691 19.4368 1.86425C19.884 2.1416 20.2525 2.52924 20.5067 2.98996C20.761 3.45069 20.8926 3.96904 20.8889 4.49527V13.0697H1.60572C1.2494 13.0701 0.907792 13.2118 0.655835 13.4638C0.403878 13.7157 0.262142 14.0573 0.261719 14.4137V16.4937C0.262722 17.598 0.564195 18.6812 1.13383 19.6273C1.70346 20.5733 2.51979 21.3465 3.49532 21.8641L2.81852 22.8625C2.77234 22.9276 2.73963 23.0013 2.7223 23.0792C2.70496 23.1571 2.70335 23.2377 2.71756 23.3163C2.73177 23.3949 2.76152 23.4698 2.80505 23.5367C2.84859 23.6036 2.90504 23.6612 2.97111 23.706C3.03717 23.7508 3.11151 23.782 3.18978 23.7977C3.26805 23.8135 3.34867 23.8134 3.42692 23.7976C3.50517 23.7818 3.57947 23.7505 3.64548 23.7056C3.71149 23.6607 3.76787 23.603 3.81132 23.5361L4.63212 22.3265C5.18788 22.4912 5.76444 22.5753 6.34412 22.5761H17.6561C18.2355 22.5752 18.8117 22.4914 19.3673 22.3273L20.1873 23.5361C20.2308 23.603 20.2872 23.6607 20.3532 23.7056C20.4192 23.7505 20.4935 23.7818 20.5717 23.7976C20.65 23.8134 20.7306 23.8135 20.8089 23.7977C20.8871 23.782 20.9615 23.7508 21.0275 23.706C21.0936 23.6612 21.15 23.6036 21.1936 23.5367C21.2371 23.4698 21.2669 23.3949 21.2811 23.3163C21.2953 23.2377 21.2937 23.1571 21.2763 23.0792C21.259 23.0013 21.2263 22.9276 21.1801 22.8625L20.5033 21.8649C21.4793 21.3475 22.296 20.5742 22.8659 19.628C23.4359 18.6818 23.7375 17.5983 23.7385 16.4937V14.4137C23.7381 14.0575 23.5965 13.716 23.3447 13.4641C23.0929 13.2121 22.7515 13.0703 22.3953 13.0697ZM16.3753 5.50647L16.2633 5.76807L11.7417 3.83127L11.8561 3.56327C12.046 3.12376 12.3602 2.74928 12.7599 2.48579C13.1597 2.22231 13.6277 2.0813 14.1065 2.08007C14.4454 2.0806 14.7805 2.15058 15.0913 2.28567C15.6882 2.54307 16.1586 3.02673 16.3994 3.63055C16.6401 4.23437 16.6314 4.90902 16.3753 5.50647ZM22.5353 16.4937C22.5332 17.7873 22.0184 19.0273 21.1037 19.942C20.1889 20.8567 18.9489 21.3716 17.6553 21.3737H6.34412C5.05051 21.3716 3.81049 20.8567 2.89577 19.942C1.98106 19.0273 1.46623 17.7873 1.46412 16.4937V14.4137C1.46412 14.3755 1.47929 14.3389 1.5063 14.3118C1.5333 14.2848 1.56993 14.2697 1.60812 14.2697H22.3953C22.4334 14.2699 22.4698 14.2851 22.4966 14.3121C22.5235 14.3391 22.5385 14.3756 22.5385 14.4137L22.5353 16.4937Z"
                              fill="#FF8A00"
                            />
                            <path
                              d="M10.9188 5.93294L10.226 6.68654C10.1289 6.80486 10.0807 6.95579 10.0913 7.10847C10.1018 7.26114 10.1703 7.40401 10.2827 7.50784C10.3952 7.61168 10.543 7.66863 10.696 7.66705C10.8491 7.66547 10.9957 7.60548 11.106 7.49934L11.7996 6.74574C11.9009 6.62751 11.9524 6.47455 11.9432 6.31909C11.9339 6.16364 11.8647 6.01784 11.7501 5.91244C11.6354 5.80704 11.4844 5.75026 11.3287 5.75409C11.173 5.75791 11.0249 5.82204 10.9156 5.93294H10.9188ZM12.2764 8.50494C12.3479 8.53854 12.4254 8.55768 12.5044 8.56126C12.5834 8.56484 12.6623 8.5528 12.7366 8.52582C12.811 8.49884 12.8792 8.45746 12.9375 8.40404C12.9958 8.35062 13.043 8.28623 13.0764 8.21454L13.4884 7.32974C13.5555 7.18546 13.5626 7.02042 13.5081 6.87091C13.4535 6.72141 13.3418 6.59969 13.1976 6.53254C13.0533 6.46539 12.8882 6.4583 12.7387 6.51284C12.5892 6.56737 12.4675 6.67906 12.4004 6.82334L11.9884 7.70734C11.9209 7.85132 11.9133 8.01619 11.9673 8.16574C12.0213 8.31529 12.1325 8.43729 12.2764 8.50494ZM14.3932 9.42814C14.5388 9.42801 14.6793 9.37494 14.7887 9.27882C14.898 9.18271 14.9687 9.05011 14.9876 8.90574L15.1196 7.89054C15.1399 7.73268 15.0968 7.5732 14.9995 7.44718C14.9023 7.32115 14.759 7.23891 14.6012 7.21854C14.4433 7.19817 14.2838 7.24135 14.1578 7.33857C14.0318 7.43578 13.9495 7.57908 13.9292 7.73694L13.798 8.75134C13.7879 8.82951 13.7933 8.9089 13.8138 8.98498C13.8344 9.06106 13.8698 9.13233 13.9179 9.19474C13.9661 9.25714 14.026 9.30945 14.0944 9.34868C14.1628 9.3879 14.2382 9.41327 14.3164 9.42334C14.3418 9.4265 14.3675 9.4281 14.3932 9.42814Z"
                              fill="#FF8A00"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_87_352">
                              <rect width="24" height="24" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        <h2>6 </h2>
                      </div>
                      <div className="cardds">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M14 3H20.6667C21.4027 3 22 3.59733 22 4.33333V5H14V4.33333C14 3.59733 14.736 3 14 3Z"
                            fill="white"
                          />
                          <path
                            d="M6 13.3333V4.33333C6 3.59733 6.57018 3 7.27273 3H20C19.2975 3 18.7273 3.59733 18.7273 4.33333V19.6667C18.7273 20.4027 18.1571 21 17.4545 21H6V20V13.3333Z"
                            fill="white"
                          />
                          <path
                            d="M18 21H3.3913C2.6233 21 2 20.4027 2 19.6667V19H16.6087V19.6667C16.6087 20.4027 17.232 21 18 21Z"
                            fill="white"
                          />
                          <path
                            d="M21.6667 5.33271C21.8507 5.33271 22.0001 5.18336 22.0001 4.99935V4.33261C22.0001 3.41318 21.2527 2.66577 20.3332 2.66577H13.6659C13.4819 2.66577 13.3325 2.81512 13.3325 2.99914C13.3325 3.18316 13.4819 3.33251 13.6659 3.33251H20.3332C20.8846 3.33251 21.3333 3.78122 21.3333 4.33261V4.99935C21.3333 5.18336 21.4827 5.33271 21.6667 5.33271Z"
                            fill="#FF8A00"
                          />
                          <path
                            d="M16.4994 20.6676H17.6661C18.2175 20.6676 18.6662 20.2189 18.6662 19.6675V4.33261C18.6662 3.95724 18.7909 3.6112 19.0003 3.33251H6.99838C6.44699 3.33251 5.99828 3.78122 5.99828 4.33261V7.66629C5.99828 7.85031 5.84893 7.99965 5.66491 7.99965C5.48089 7.99965 5.33154 7.85031 5.33154 7.66629V4.33261C5.33154 3.41318 6.07895 2.66577 6.99838 2.66577H20.3331C20.5171 2.66577 20.6665 2.81512 20.6665 2.99914C20.6665 3.18316 20.5171 3.33251 20.3331 3.33251C19.7817 3.33251 19.333 3.78122 19.333 4.33261V19.6675C19.333 20.5869 18.5856 21.3344 17.6661 21.3344H16.4994V20.6676Z"
                            fill="#FF8A00"
                          />
                          <path
                            d="M1.99805 19.6676V19.0008C1.99805 18.8168 2.1474 18.6675 2.33141 18.6675H16.3329C16.5169 18.6675 16.6662 18.8168 16.6662 19.0008V19.6676C16.6662 20.219 17.1149 20.6677 17.6663 20.6677C17.8503 20.6677 17.9997 20.817 17.9997 21.001C17.9997 21.1851 17.8503 21.3344 17.6663 21.3344H3.66489C2.74546 21.3344 1.99805 20.587 1.99805 19.6676ZM15.9995 19.6676V19.3342H2.66478V19.6676C2.66478 20.219 3.1135 20.6677 3.66489 20.6677H16.3335C16.1242 20.389 15.9995 20.0429 15.9995 19.6676ZM10.999 9.99991H11.6657C11.8497 9.99991 11.9991 9.85056 11.9991 9.66654C11.9991 9.48252 11.8497 9.33318 11.6657 9.33318H10.999C10.815 9.33318 10.6656 9.48252 10.6656 9.66654C10.6656 9.85056 10.815 9.99991 10.999 9.99991ZM12.9992 9.99991H13.6659C13.8499 9.99991 13.9993 9.85056 13.9993 9.66654C13.9993 9.48252 13.8499 9.33318 13.6659 9.33318H12.9992C12.8152 9.33318 12.6658 9.48252 12.6658 9.66654C12.6658 9.85056 12.8152 9.99991 12.9992 9.99991ZM14.9994 9.99991H16.9996C17.1836 9.99991 17.333 9.85056 17.333 9.66654C17.333 9.48252 17.1836 9.33318 16.9996 9.33318H14.9994C14.8154 9.33318 14.666 9.48252 14.666 9.66654C14.666 9.85056 14.8154 9.99991 14.9994 9.99991ZM13.6659 11.3334H16.9996C17.1836 11.3334 17.333 11.184 17.333 11C17.333 10.816 17.1836 10.6666 16.9996 10.6666H13.6659C13.4819 10.6666 13.3325 10.816 13.3325 11C13.3325 11.184 13.4819 11.3334 13.6659 11.3334ZM13.6659 8.66644H16.9996C17.1836 8.66644 17.333 8.51709 17.333 8.33307C17.333 8.14905 17.1836 7.99971 16.9996 7.99971H13.6659C13.4819 7.99971 13.3325 8.14905 13.3325 8.33307C13.3325 8.51709 13.4819 8.66644 13.6659 8.66644ZM11.6657 8.66644H12.3324C12.5165 8.66644 12.6658 8.51709 12.6658 8.33307C12.6658 8.14905 12.5165 7.99971 12.3324 7.99971H11.6657C11.4817 7.99971 11.3323 8.14905 11.3323 8.33307C11.3323 8.51709 11.4817 8.66644 11.6657 8.66644ZM9.6655 8.66644H10.3322C10.5163 8.66644 10.6656 8.51709 10.6656 8.33307C10.6656 8.14905 10.5163 7.99971 10.3322 7.99971H9.6655C9.48148 7.99971 9.33214 8.14905 9.33214 8.33307C9.33214 8.51709 9.48148 8.66644 9.6655 8.66644ZM10.999 7.33297H13.6659C13.8499 7.33297 13.9993 7.18362 13.9993 6.9996C13.9993 6.81558 13.8499 6.66623 13.6659 6.66623H10.999C10.815 6.66623 10.6656 6.81558 10.6656 6.9996C10.6656 7.18362 10.815 7.33297 10.999 7.33297ZM7.6653 7.33297H9.6655C9.84952 7.33297 9.99887 7.18362 9.99887 6.9996C9.99887 6.81558 9.84952 6.66623 9.6655 6.66623H7.6653C7.48128 6.66623 7.33193 6.81558 7.33193 6.9996C7.33193 7.18362 7.48128 7.33297 7.6653 7.33297ZM14.9994 7.33297H16.9996C17.1836 7.33297 17.333 7.18362 17.333 6.9996C17.333 6.81558 17.1836 6.66623 16.9996 6.66623H14.9994C14.8154 6.66623 14.666 6.81558 14.666 6.9996C14.666 7.18362 14.8154 7.33297 14.9994 7.33297ZM7.6653 5.9995H10.999C11.183 5.9995 11.3323 5.85015 11.3323 5.66613C11.3323 5.48211 11.183 5.33276 10.999 5.33276H7.6653C7.48128 5.33276 7.33193 5.48211 7.33193 5.66613C7.33193 5.85015 7.48128 5.9995 7.6653 5.9995ZM12.3324 5.9995H12.9992C13.1832 5.9995 13.3325 5.85015 13.3325 5.66613C13.3325 5.48211 13.1832 5.33276 12.9992 5.33276H12.3324C12.1484 5.33276 11.9991 5.48211 11.9991 5.66613C11.9991 5.85015 12.1484 5.9995 12.3324 5.9995ZM14.3327 5.9995H16.9996C17.1836 5.9995 17.333 5.85015 17.333 5.66613C17.333 5.48211 17.1836 5.33276 16.9996 5.33276H14.3327C14.1486 5.33276 13.9993 5.48211 13.9993 5.66613C13.9993 5.85015 14.1486 5.9995 14.3327 5.9995Z"
                            fill="#FF8A00"
                          />
                          <path
                            d="M6.99851 9.33374C6.53513 9.33374 6.08775 9.40375 5.66504 9.52976V13.3335V18.472C6.08775 18.598 6.53513 18.668 6.99851 18.668C9.57544 18.668 11.6657 16.5778 11.6657 14.0009C11.6657 11.424 9.57544 9.33374 6.99851 9.33374Z"
                            fill="white"
                          />
                          <path
                            d="M6.66532 17.668C9.0588 17.668 10.9991 15.7277 10.9991 13.3343C10.9991 10.9408 9.0588 9.00049 6.66532 9.00049C4.27184 9.00049 2.33154 10.9408 2.33154 13.3343C2.33154 15.7277 4.27184 17.668 6.66532 17.668Z"
                            fill="white"
                          />
                          <path
                            d="M7.33183 9.6665C4.93891 9.6665 2.99805 11.6074 2.99805 14.001C2.99805 15.0277 3.35742 15.9698 3.95415 16.7126C4.69689 17.31 5.63899 17.6687 6.66509 17.6687C9.058 17.6687 10.9989 15.7278 10.9989 13.3342C10.9989 12.3074 10.6395 11.3653 10.0428 10.6226C9.30003 10.0252 8.35793 9.6665 7.33183 9.6665Z"
                            fill="white"
                          />
                          <path
                            d="M6.64689 18.0107C5.40142 18.0107 4.2313 17.5266 3.35255 16.6472C1.80305 15.0984 1.53703 12.7175 2.70715 10.8586C2.80516 10.7026 3.01118 10.6572 3.16653 10.7539C3.32188 10.8519 3.36922 11.0579 3.27054 11.2133C2.26777 12.8075 2.49513 14.8483 3.82326 16.1758C4.57667 16.9292 5.57944 17.3439 6.64622 17.3439C6.64889 17.3439 6.65155 17.3439 6.65489 17.3439C7.72566 17.3419 8.73377 16.9226 9.49318 16.1631C10.2526 15.4037 10.672 14.3963 10.674 13.3248C10.676 12.2541 10.2613 11.2486 9.50585 10.4932C8.18971 9.17642 6.09416 8.95107 4.52067 9.95517C4.36532 10.0525 4.1593 10.0098 4.05995 9.85383C3.96128 9.69848 4.00661 9.49245 4.1613 9.39378C5.99615 8.22232 8.4424 8.48635 9.97723 10.0225C10.8587 10.9039 11.3434 12.0774 11.3407 13.3268C11.338 14.5756 10.8493 15.7504 9.96456 16.6352C9.0798 17.5199 7.90502 18.0093 6.65622 18.0113C6.65289 18.0107 6.65022 18.0107 6.64689 18.0107Z"
                            fill="#FF8A00"
                          />
                          <path
                            d="M6.66515 16.0011C7.59991 16.0011 8.33198 15.269 8.33198 14.3343C8.33198 13.5775 7.81793 13.0261 6.80449 12.6954L6.72915 12.6708C6.34911 12.5468 5.99841 12.3801 5.99841 12.0007C5.99841 11.608 6.27244 11.334 6.66515 11.334C7.13453 11.334 7.44789 11.586 7.45056 11.5887C7.59257 11.7073 7.80193 11.6887 7.92061 11.5487C8.03929 11.4073 8.02062 11.198 7.87994 11.0793C7.85993 11.0626 7.38255 10.6672 6.66515 10.6672C5.9044 10.6672 5.33167 11.2406 5.33167 12.0007C5.33167 12.9168 6.22777 13.2095 6.5218 13.3042L6.59714 13.3288C7.31655 13.5635 7.66525 13.8929 7.66525 14.3343C7.66525 14.9043 7.2352 15.3344 6.66515 15.3344C6.04641 15.3344 5.69238 14.9263 5.59837 14.801C5.48769 14.653 5.27834 14.6243 5.13165 14.7337C4.98364 14.8443 4.95364 15.053 5.06431 15.2004C5.20566 15.3891 5.73705 16.0011 6.66515 16.0011Z"
                            fill="#FF8A00"
                          />
                          <path
                            d="M6.66491 16.6678C6.84893 16.6678 6.99828 16.5185 6.99828 16.3345V16.0011C6.99828 15.8171 6.84893 15.6677 6.66491 15.6677C6.48089 15.6677 6.33154 15.8171 6.33154 16.0011V16.3345C6.33154 16.5185 6.48089 16.6678 6.66491 16.6678ZM6.66491 11.0006C6.84893 11.0006 6.99828 10.8512 6.99828 10.6672V10.3339C6.99828 10.1498 6.84893 10.0005 6.66491 10.0005C6.48089 10.0005 6.33154 10.1498 6.33154 10.3339V10.6672C6.33154 10.8512 6.48089 11.0006 6.66491 11.0006Z"
                            fill="#FF8A00"
                          />
                        </svg>
                        <h2>8-10%</h2>
                      </div>
                    </div>
                    <div className="botttom_side">
                      {/* <h3> 500,000</h3> */}
                      <button>
                        See Details
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="19"
                          viewBox="0 0 18 19"
                          fill="#FF8A00"
                        >
                          <path
                            d="M3.75 9.5H14.25M14.25 9.5L9.75 5M14.25 9.5L9.75 14"
                            stroke="#FF8A00"
                            stroke-width="1.2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Duplex;
